// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1TD7t","buttons":"Footer_buttons__2FM_A"};